export enum EGuildRole {
  /* eslint-disable no-magic-numbers */
  None = /*          */ 0b00000000,
  Member = /*        */ 0b00000001,
  Owner = /*         */ 0b00000010,
  Agent = /*         */ 0b00000100,

  // eslint-disable-next-line no-bitwise
  AgentOrOwner = /*  */ EGuildRole.Agent | EGuildRole.Owner,
  /* eslint-enable no-magic-numbers */
}

export interface UserGuildRole {
  role: EGuildRole
}

export interface User {
  room?: UserRoom
  user: UserInfo
}

export interface UserRoom {
  room_id?: number
}

export interface UserInfo {
  user_id: number
  username: string
  introduction: string
  iconurl: string
  group?: string // TODO: remove
  /** @deprecated */
  token?: string
  confirm?: number
  // TODO: 2021/9/28 sweetliquid 可能是忘记删除的旧逻辑遗留字段
  balance?: number
  bind?: number
  followed?: boolean
  is_guest: boolean
  isGuildOwner?: boolean
  guildRole?: EGuildRole
  room_id?: number
  guild_id?: number
}
